import { ref, reactive, onMounted } from 'vue';
import { getUserFileList } from '@/api/user.api';

/* eslint-disable max-lines-per-function */
export default (props) => {
    onMounted(() => {
        // getFileList();
    });
    const loading = ref(false);
    const fileList = ref([]);
    const columns = ref([
        {
            label: '文件名',
            prop: 'localFileName',
            width: '160'
        },
        {
            label: '状态',
            prop: 'fileStatus',
            width: '100'
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: '150'
        }
    ]);
    const paginationObj = reactive({
        currentPage: 1,
        pageSize: 10,
        loadMoreStatus: false, // 加载更多的状态
        loadMoreFinished: false, // 加载完成状态，true为已全部加载完
        loadMoreText: '' // 下拉加载显示的文字
    });
    const updateFileList = (list, text) => {
        loading.value = true;
        fileList.value = [];
        setTimeout(() => {
            fileList.value = JSON.parse(JSON.stringify(list));
            paginationObj.loadMoreText = text;
            loading.value = false;
            getFileList();
        }, 0);
    };
    const loadMoreList = text => {
        paginationObj.loadMoreText = text;
    };
    const getFileList = isLoadMore => {
        const params = {
            param: {},
            pageSize: paginationObj.pageSize,
            pageNo: isLoadMore ? paginationObj.currentPage + 1 : 1
        };
        getUserFileList(params).then(res => {
            if (res && +res.code === 0) {
                const list = res.data.list || res.data.records;
                list.forEach(item => {
                    if (!item.downUrl && !item.errorInfo) {
                        item.fileStatusPoint = 'orange';
                        item.fileStatusText = '生成中';
                    } else if (item.downUrl) {
                        item.fileStatusPoint = 'blue';
                        item.fileStatusText = '已生成';
                    } else if (item.errorInfo) {
                        item.fileStatusPoint = 'red';
                        item.fileStatusText = '失败';
                    } else {
                        item.fileStatusPoint = '';
                        item.fileStatusText = '';
                    }
                });
                if (isLoadMore === 'more') {
                    paginationObj.currentPage = paginationObj.currentPage + 1;
                    fileList.value.push(...list);
                } else {
                    fileList.value = list;
                }
            }
        });
    };
    return {
        loading,
        fileList,
        columns,
        paginationObj,
        updateFileList,
        loadMoreList,
        getFileList,
        getUserFileList
    };
};
